/**
 * Cor de texto legível (preto/branco) sobre um preenchimento sólido dessa cor.
 * YIQ (percepção de luminância): >= 150 é claro demais para texto branco.
 */
export function getContrastTextColor(hex) {
  const rgb = hexToRgb(hex)
  if (!rgb) return '#000000'

  const yiq = (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000
  return yiq >= 150 ? '#000000' : '#ffffff'
}

/**
 * Para texto que usa a própria cor (não um preenchimento): mantém a cor
 * quando ela já é escura o bastante para ler sobre fundo claro/branco, e
 * cai para preto quando for viva/clara demais (ex: amarelo).
 */
export function getReadableColor(hex) {
  return getContrastTextColor(hex) === '#ffffff' ? hex : '#000000'
}

function hexToRgb(hex) {
  if (!hex) return null
  const clean = hex.replace('#', '')
  const full = clean.length === 3 ? clean.split('').map(c => c + c).join('') : clean
  if (full.length !== 6) return null

  const r = parseInt(full.substr(0, 2), 16)
  const g = parseInt(full.substr(2, 2), 16)
  const b = parseInt(full.substr(4, 2), 16)
  if ([r, g, b].some(Number.isNaN)) return null

  return { r, g, b }
}
